import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faMagnifyingGlass, faTableCellsLarge, } from '@fortawesome/free-solid-svg-icons';
import { loading } from '../../redux/selectors/loading';
const FILTERS = ['published', 'draft'];
const ListControlsComponent = ({ totalLength, layout, updateLayout, activeFilter, updateFilter, page, updatePage, }) => {
    const totalPages = Math.ceil(totalLength / page.size);
    const [searchTerm, setSearchTerm] = useState('');
    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(e.target.value);
        updateFilter({
            ...activeFilter,
            text: term,
        });
    };
    const handlePageSizeChange = (e) => {
        updatePage({ ...page, size: Number(e.target.value) });
    };
    return (React.createElement("div", { className: "list-controls" },
        React.createElement("div", { id: "filters" }, FILTERS.map((filter) => (React.createElement("button", { key: filter, className: `btn--filter${activeFilter.status === filter ? '--active' : ''}`, onClick: () => updateFilter({
                status: activeFilter.status === filter ? undefined : filter,
                text: activeFilter.text,
            }) }, filter.toUpperCase())))),
        React.createElement("div", { id: "search" },
            React.createElement("div", { className: "search-container" },
                React.createElement(FontAwesomeIcon, { icon: faMagnifyingGlass }),
                React.createElement("input", { type: "text", className: "search", placeholder: "Search activities", value: searchTerm, onChange: handleSearch }))),
        React.createElement("div", { id: "pagination", onChange: handlePageSizeChange },
            totalLength > page.size && (React.createElement(React.Fragment, null,
                page.current == 1 ? (React.createElement("span", { className: "pagination-navigation--disabled" }, "<")) : (React.createElement("a", { className: "pagination-navigation", onClick: () => updatePage({ ...page, current: page.current - 1 }), href: "#" }, "<")),
                [...Array(totalPages)].map((_, i) => page.current == i + 1 ? (React.createElement("span", { key: `s-${i}`, className: "pagination-navigation--disabled" }, i + 1)) : (React.createElement("a", { key: `a-${i}`, className: "pagination-navigation", onClick: () => updatePage({ ...page, current: i + 1 }), href: "#" }, i + 1))),
                page.current == totalPages ? (React.createElement("span", { className: "pagination-navigation--disabled" }, ">")) : (React.createElement("a", { className: "pagination-navigation", onClick: () => updatePage({ ...page, current: page.current + 1 }), href: "#" }, ">")))),
            layout === 'List' && (React.createElement("select", { className: "pagination-select", defaultValue: page.size },
                React.createElement("option", { value: 5 }, "5"),
                React.createElement("option", { value: 10 }, "10"),
                React.createElement("option", { value: 20 }, "20"),
                React.createElement("option", { value: 50 }, "50")))),
        React.createElement("div", { id: "layout" },
            React.createElement(FontAwesomeIcon, { icon: faTableCellsLarge, className: `layout${layout === 'Grid' ? '--active' : ''}`, onClick: () => updateLayout('Grid') }),
            React.createElement(FontAwesomeIcon, { icon: faList, className: `layout${layout === 'List' ? '--active' : ''}`, onClick: () => updateLayout('List') }))));
};
const mapStateToProps = (state) => ({
    loading: loading(state.quizState.loading, state.crosswordState.loading),
    error: state.crosswordState.error,
    errorDetail: state.crosswordState.errorDetail,
});
export const ListControls = connect(mapStateToProps)(ListControlsComponent);
